import { homeResources } from "../Resources/Home";
import { industriesResources } from "../Resources/Industries";
import { getLang } from "../lib";
import { useEffect } from "react";
import "./Home.css";
import FadeInOnScroll from "./FadeInOnScroll";
import { ROUTES, getRoutePath } from "../Resources/routes";
import { dropdownIds } from "../Resources/SharedResources";
import useScrollOrNavigate from "./useScrollOrNavigate";

function Home() {
    const lang = getLang();
    const handleScrollOrNavigate = useScrollOrNavigate();

    const industryList = [
        { Id: dropdownIds.industries.pharma, Data: industriesResources[lang].Pharmaceuticals },
        { Id: dropdownIds.industries.tech, Data: industriesResources[lang].Technology },
        { Id: dropdownIds.industries.manufacturing, Data: industriesResources[lang].Manufacturing },
        { Id: dropdownIds.industries.retail, Data: industriesResources[lang].Retail },
        { Id: dropdownIds.industries.professional, Data: industriesResources[lang].Professional },
        { Id: dropdownIds.industries.healthcare, Data: industriesResources[lang].Healthcare },
    ];

    const valueProps = [
        { title: homeResources[lang].ValuePropTitle1, desc: homeResources[lang].ValuePropDesc1, id: dropdownIds.services.BPO },
        { title: homeResources[lang].ValuePropTitle2, desc: homeResources[lang].ValuePropDesc2, id: dropdownIds.services.FPA },
        { title: homeResources[lang].ValuePropTitle3, desc: homeResources[lang].ValuePropDesc3, id: dropdownIds.services.CFO },
    ];

    const whyUs = [
        { icon: "👨‍💼", desc: homeResources[lang].WhyChooseUsDesc1 },
        { icon: "🛠️", desc: homeResources[lang].WhyChooseUsDesc2 },
        { icon: "💰", desc: homeResources[lang].WhyChooseUsDesc3 },
        { icon: "📈", desc: homeResources[lang].WhyChooseUsDesc4 },
    ];

    useEffect(() => {
        document.title = "Welcome";
    }, []);

    const Card = ({ title, desc, linkId, linkRoute }) => (
        <div className="vp-card">
            <h3>{title}</h3>
            <p>{desc}</p>
            {linkId && linkRoute && (
                <span
                    className="learn-more-link"
                    onClick={() => handleScrollOrNavigate(linkId, linkRoute)}
                >
                    {homeResources[lang].LearnMore}
                </span>
            )}
        </div>
    );

    const WhyCard = ({ icon, desc }) => (
        <div className="why-card">
            <div className="icon">{icon}</div>
            <p>{desc}</p>
        </div>
    );

    return (
        <div className="h-p">
            {/* Showcase */}
            <div className="showcase">
                <img src="/images/home.jpg" alt="showcase" />
                <div className="hero-text">
                    <h1>{homeResources[lang].HeroHeadline}</h1>
                    <p>{homeResources[lang].HeroSubheadline}</p>
                    <div className="cta-section">
                        <a href={getRoutePath(ROUTES.ABOUT, lang)} className="primaryCTA-btn">
                            {homeResources[lang].PrimaryCTA}
                        </a>
                        <a href={getRoutePath(ROUTES.SERVICES, lang)} className="secondaryCTA-btn">
                            {homeResources[lang].SecondaryCTA}
                        </a>
                    </div>
                </div>
            </div>

            {/* Value Proposition */}
            <section className="value-prop">
                <FadeInOnScroll>
                    <h2 className="section-title">{homeResources[lang].ValuePropTitle}</h2>
                </FadeInOnScroll>
                <div className="vp-grid">
                    {valueProps.map((vp, idx) => (
                        <FadeInOnScroll key={idx} delay={0.1 * (idx + 1)}>
                            <Card
                                title={vp.title}
                                desc={vp.desc}
                                linkId={vp.id}
                                linkRoute={getRoutePath(ROUTES.SERVICES, lang)}
                            />
                        </FadeInOnScroll>
                    ))}
                </div>

                {/* Industries */}
                <FadeInOnScroll>
                    <h2 className="section-title">{industriesResources[lang].IndustryExpertise}</h2>
                </FadeInOnScroll>
                <div className="vp-grid">
                    {industryList.map((industry, idx) => (
                        <FadeInOnScroll key={industry.Id} delay={0.1 * (idx + 1)}>
                            <Card
                                title={industry.Data.Title}
                                desc={industry.Data.Overview}
                                linkId={industry.Id}
                                linkRoute={getRoutePath(ROUTES.INDUSTRIES, lang)}
                            />
                        </FadeInOnScroll>
                    ))}
                </div>

                {/* Why Choose Us */}
                <FadeInOnScroll>
                    <h2 className="section-title">{homeResources[lang].WhyChooseUsTitle}</h2>
                </FadeInOnScroll>
                <div className="why-us-grid">
                    {whyUs.map((item, idx) => (
                        <FadeInOnScroll key={idx} delay={0.1 * (idx + 1)}>
                            <WhyCard icon={item.icon} desc={item.desc} />
                        </FadeInOnScroll>
                    ))}
                </div>

                <FadeInOnScroll delay={0.2}>
                    <div className="callout">{homeResources[lang].Callout}</div>
                </FadeInOnScroll>
            </section>
        </div>
    );
}

export default Home;
